<i>Automated Schedules based on Soil Moisture levels</i>
<app-weekly-schedule-editor
  [schedulesInput]="editSchedules"
  (scheduleChange)="scheduleChange.emit($event)"
  (scheduleAdd)="scheduleAdd.emit($event)"
  (scheduleDelete)="scheduleDelete.emit($event)"
  (clearSchedules)="clearSchedules.emit()">
</app-weekly-schedule-editor>